export const CONTEXT_DEPTHS = [
  {
    value: "sender_contact_details",
    label: "Sender/Contact Details",
    shortLabel: "Sender",
    icon: "fa-user",
    tooltipTitle: "Sender/Contact Details",
    description:
      "Sends basic sender and recipient info — name, email, phone, status, labels, and recruiting fields. Fast and focused.",
  },
  {
    value: "production",
    label: "+ Production",
    shortLabel: "+ Prod",
    icon: "fa-chart-bar",
    tooltipTitle: "+ Production",
    description:
      "Adds production stats (transactions, volume, YoY change) plus Relitix, Courted, and agent-alerts data. Best when you need numbers in the message.",
  },
  {
    value: "full_activity",
    label: "Full Activity",
    shortLabel: "Full",
    icon: "fa-history",
    tooltipTitle: "Full Activity",
    description:
      "Everything from the lower levels plus engagement history, recent messages, notes, web links, job applications, and resume. Maximum context.",
  },
];

export const DEFAULT_CONTEXT_DEPTH = "sender_contact_details";
export const DEPTH_STORAGE_KEY = "ai_assist_context_depth";

export default CONTEXT_DEPTHS;
